const AppConsts = {
  userManagement: {
    defaultAdminUserName: "admin"
  },
  app: {
    defaultName: "为垦小绿伞"
  },
  localization: {
    defaultLocalizationSourceName: "Platform-zh-Hans"
  },
  authorization: {
    encrptedAuthTokenName: "enc_auth_token"
  },
  appBaseUrl: "",
  remoteServiceBaseUrl: "",
  idServerUrl: ""
};
export default AppConsts;
